<template>
  <div class="form">
    <div class="form__content">
      <h1 class="extra-large-headline">One last thing...</h1>
      <p class="bodycopy">
        We need you to take a clear selfie of yourself holding holding your form
        of identification.
      </p>
      <ul class="form__selfie-instructions bodycopy">
        <li>
          Ensure that we can clearly see your face in the selfie, no hats or
          sunglasses please!
        </li>
        <li>Ensure that your document is legible.</li>
        <li>The photo needs to have been taken today.</li>
      </ul>
    </div>
    <form @submit.prevent>
      <FileUploadField
        name="selfieDocument"
        label="Upload your selfie"
        placeholder="Select or drag your file"
        iconType="VerificationCircle"
        :errors="form.selfieDocumentErrors"
        @updateFile="updateFiles"
      />

      <ButtonBase
        :isDisabled="formHasErrors || globalStore.getIsFormLoading"
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="handleFormSubmit"
      >
        My selfie is clear and legible
      </ButtonBase>
    </form>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

import useApiHelpers from "@/composables/api/helpers";
import useCustomerActions from "@/composables/api/useCustomerActions";

import FileUploadField from "@/components/ui/inputs/FileUploadField.vue";
import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";
import useFormValidation from "@/composables/validations/useFormValidation";

const router = useRouter();
const globalStore = useGlobalStore();
const identityQueueStore = useIdentityQueueStore();

const { validateFileInput } = useFormValidation();
const { postRequest } = useApiHelpers();
const { fetchCustomerId } = useCustomerActions();
const form = ref({
  selfieDocument: [],
  selfieDocumentErrors: "",
});

const updateFiles = (file) => {
  const fileValidationErrors = validateFileInput("selfieDocument", file);
  form.value.selfieDocument = file;

  form.value.selfieDocumentErrors = fileValidationErrors;
};

const handleFormSubmit = async () => {
  const custId = await fetchCustomerId();
  const formData = new FormData();
  const docSubType = "";
  const docType = "selfie";

  formData.set("documentFile", form.value.selfieDocument);
  formData.set("documentType", docType);
  formData.set("documentSubType", docSubType);
  formData.set("documentReference", custId);

  globalStore.setIsFormLoading(true);
  postRequest("documents", formData, () =>
    router.push(identityQueueStore.getNextIdentityRoute)
  );
};

const formHasErrors = computed(() => {
  const anyErrors = form.value.selfieDocumentErrors !== "";
  const anyFieldsEmpty = form.value.selfieDocument.length === 0;
  return anyErrors || anyFieldsEmpty;
});
</script>
<style lang="scss" scoped>
.form {
  .bodycopy {
    margin-bottom: 1rem;
    @include breakpoint($min-m) {
      margin-bottom: 1.5rem;
    }
  }
  &__selfie-instructions {
    list-style: unset;
    padding-inline: 1.5rem;

    li {
      font-size: $font-body;
      line-height: 1.5;
    }
  }
}
</style>
